const url = window.location.pathname.split("/")[1];
const userRoleCode = atob(localStorage.getItem("argument6"));

console.log("userRoleCode", userRoleCode);

const SidebarContant = [
  {
    show: true,
    modalName: "Utility",
    title: "Master",
    moduleId: 1,
    content: [
      // { name: "categoryMaster", title: "Category master" },
      // { name: "manufactureMapping", title: "Manufacture Mapping" },
      // { name: "gradeMaster", title: "Grade Master" },
      // { name: "markMaster", title: "Mark Master" },
      { linkId: 1, name: "createStateMaster", title: "Create State Master" },
      {
        linkId: 2,
        name: "createAuctionCenterModal",
        title: "Create Auction Center",
      },
      { linkId: 3, name: "createCategory", title: "Create Category" },
      { linkId: 4, name: "createTeaType", title: "Create Tea Type" },
      { linkId: 5, name: "createSubTeaType", title: "Create Sub Tea Type" },
      {
        linkId: 6,
        name: "createPlantationDistrictMaster",
        title: "Create Plantation District Master",
      },
      {
        linkId: 7,
        name: "createRevenueDistrictMaster",
        title: "Create Revenue District Master",
      },
      { linkId: 8, name: "createGrade", title: "Create Grade" },
      { linkId: 9, name: "createFactoryType", title: "Create Factory Type" },
      { linkId: 10, name: "createRole", title: "Create Role" },
      { linkId: 11, name: "chargeCode", title: "Charge Code" },
      { linkId: 12, name: "createChargeMaster", title: "Create Charge Master" },
      { linkId: 13, name: "createTaxMaster", title: "Create Tax Master" },
      {
        linkId: 14,
        name: "CreateConfigureParameter",
        title: "Create Configure Parameter",
      },
      { linkId: 15, name: "createSpuMaster", title: "Create SPU Master" },
      {
        linkId: 16,
        name: "createBankAccountDetail",
        title: "Create Bank Account Detail",
      },
      // {linkId:68, name: "registerUser", title: "Register User" },
      // { name: "createRegistration", title: "AUCTIONEER Registration" },
      // { linkId: 17, name: "userRegistartion", title: "TEABOARD User Registration" },
      // { linkId: 18, name: "toauserRegistration", title: "TAO User Registration" },
      // { name: "BuyerRegistartion", title: "Buyer Registartion" },
      // { linkId: 29, name: "CreateMark", title: "Create Mark" },
      { linkId: 32, name: "CreatepackageType", title: "Create Package Type" },
      { linkId: 33, name: "CreatepackageSize", title: "Create Package Size" },
      { linkId: 31, name: "ruleEngine", title: "Manage Rule Engine" },
      { linkId: 30, name: "CreateGrace", title: "Create Grace" },
      { linkId: 1, name: "createSptf", title: "Create SPTF Recovery" },
      { linkId: 78, name: "createNotification", title: "Create Notification" },
      // { name: "manageRole", title: "Manage Roles" },
      // {
      //   name: "WarehouseUserRegistration",
      //   title: "Warehouse User Registration",
      // },
    ],
  },

  {
    title: "Pre-Auction",
    moduleId: 2,
    content: [
      { linkId: 34, name: "saleProgramMaster", title: "Sale Program master" },
      { linkId: 35, name: "invoice", title: "Invoice" },
      { linkId: 36, name: "awr", title: "AWR" },
      { linkId: 38, name: "lotnoseries", title: "Lot No. Series" },
      { linkId: 37, name: "kutcha", title: "Kutcha (Draft) Catalog" },
      { linkId: 39, name: "AuctionSession", title: "Auction Session" },
      { linkId: 40, name: "sampleshortage", title: "Sample & Shortage" },
      { linkId: 41, name: "auctioncatalog", title: "Auction Catalog" },
      {
        linkId: 51,
        name: "auctioncatalogBuyer",
        title: "Auction Catalog Buyer",
      },
      { linkId: 42, name: "groupMaster", title: "Group Master" },
      { linkId: 43, name: "maxBidEntry", title: "Max Bid Entry" },
      // { name: "businessRule", title: "Business Rule" },
      //       --Kutcha (Draft) Catalog
      // --Auction Session
      // --Pre-Auction Status Report
      // --Lot No. Series
      // --Tea Quality Parameters
      // --Seller Charges
      {
        linkId: 45,
        name: "preAuctionStatusReport",
        title: "Pre-Auction Status Report",
      },
      {
        linkId: 46,
        name: "teaQualityReport",
        title: "Tea Quality Parameters",
      },
      {
        linkId: 47,
        name: "prsAuctionCatalogBuyer",
        title: "PRS Auction Catalog Buyer",
      },
      { linkId: 48, name: "prsAuctionCatalog", title: "PRS Auction Catalog" },
      {
        linkId: 49,
        name: "saleProgramBuyerSallerReport",
        title: "Sale Programe Buyer ",
      },
      // {linkId:43,
      //   name: "saleProgramBuyerSallerReport",
      //   title: "Sale Programe Buyer Saller Report",
      // },
      {
        linkId: 50,
        name: "auctionSessionBuyerSallerReport",
        title: "Auction Session Buyer",
      },
      {
        linkId: 77,
        name: "SellerCharges",
        title: "Seller Charges",
      },
      // { name: "auctionSessionBuyerSallerReport", title: "Auction Session Buyer" },
    ],
    show: true,
    modalName: "preAuction",
  },
  url == "englishauction"
    ? {
        title: "Auction",

        content: [
          {
            linkId: 52,
            name: "viewBidBook1",
            title: "View Bid Book",
          },
          {
            linkId: 52,
            name: "viewNotification1",
            title: "View Notification",
          },
        ],
        show: true,
        modalName: "Auction",
        moduleId: 3,
      }
    : {
        title: "Auction",

        content: [
          {
            linkId: 52,
            name: "auctionSearchBidBookModal",
            title: "View Bid Book",
          },

          {
            linkId: 52,
            name: "viewNotification1",
            title: "View Notification",
          },
        ],
        show: true,
        modalName: "Auction",
        moduleId: 3,
      },

  {
    title: "Post Auction",
    moduleId: 4,
    content: [
      { linkId: 53, name: "viewDealBookModal", title: "View Deal Book" },
      {
        linkId: 54,
        name: "transferDealBookModal",
        title: "Transfer Post Auction Data",
      },

      {
        linkId: 57,
        name: "generateSellerTaxInvoiceModal",
        title: "Generate Seller to Auctioneer Tax Invoice",
      },
      {
        linkId: 0,
        name: "generateBuyerTaxInvoice",
        title: "Buyer Tax Invoice",
      },
      {
        linkId: 63,
        name: "buyerTaxInvoice",
        title: "Generate Buyer Tax Invoice",
      },
      {
        linkId: 64,
        name: "individualTaxInvoice",
        title: "Individual Buyer Tax Invoice Generation",
      },
      {
        linkId: 56,
        name: "ViewBuyerTaxInvoice",
        title: "View Buyer Tax Invoice",
      },
      {
        linkId: 61,
        name: "AllocateFundBuyerModel",
        title: "Allocation of fund",
      },

      {
        linkId: 59,
        name: "deliveryInstructionAdviceModal",
        title: "Delivery Instruction / Advice",
      },
      {
        linkId: 58,
        name: "sellerTaxInvoice",
        title: "Generate Seller Tax Invoice",
      },
      { linkId: 55, name: "InvoiceListModal", title: "Invoice List" },
      {
        linkId: 62,
        name: "RedemptionRequestModel",
        title: "Redemption Request for OPESS Balance",
      },

      {
        linkId: 65,
        name: "addWarehouseBillUploads",
        title: "Warehouse Bill Uploads",
      },
      {
        linkId: 67,
        name: "rejectWarehouseBill",
        title: "Reject Warehouse Bill",
      },
    ],

    show: true,
    modalName: "PostAuction",
  },

  {
    title: "Report",
    moduleId: 5,
    content: [
      userRoleCode == "AUCTIONEER" ||
      userRoleCode == "ASSOCIATEAUCTIONEER" ||
      userRoleCode == "POSTAUCTIONASSOCIATEAUCTIONEER" ||
      userRoleCode == "SUPERADMIN"
        ? {
            name: "BankReportsUserRoleWise",
            title: "Auctioneer Detailed MIS",
            linkId: 100,
          }
        : "",
      (userRoleCode == "AUCTIONEER" ||
        userRoleCode == "ASSOCIATEAUCTIONEER" ||
        userRoleCode == "POSTAUCTIONASSOCIATEAUCTIONEER" ||
        userRoleCode == "SUPERADMIN") &&
      url != "englishauction"
        ? {
            name: "test10",
            title: "Auctioneer Pay In Pay Out",
            linkId: 102,
          }
        : "",
      (userRoleCode == "AUCTIONEER" ||
        userRoleCode == "ASSOCIATEAUCTIONEER" ||
        userRoleCode == "POSTAUCTIONASSOCIATEAUCTIONEER" ||
        userRoleCode == "SUPERADMIN") &&
      url == "englishauction"
        ? {
            name: "test121",
            title: "Auctioneer Pay In Pay Out",
            linkId: 102,
          }
        : "",
      userRoleCode == "AUCTIONEER" ||
      userRoleCode == "ASSOCIATEAUCTIONEER" ||
      userRoleCode == "POSTAUCTIONASSOCIATEAUCTIONEER" ||
      userRoleCode == "SUPERADMIN"
        ? {
            name: "BankReportsUserRoleWise",
            title: "Auctioneer Statement",
            linkId: 101,
          }
        : "",
      userRoleCode == "BUYER" ||
      userRoleCode == "ASSOCIATEBUYER" ||
      userRoleCode == "POSTAUCTIONASSOCIATEBUYER" ||
      userRoleCode == "SUPERADMIN"
        ? {
            name: "BankReportsUserRoleWise",
            title: "Buyer Detailed MIS",
            linkId: 103,
          }
        : "",
      userRoleCode == "BUYER" ||
      userRoleCode == "ASSOCIATEBUYER" ||
      userRoleCode == "POSTAUCTIONASSOCIATEBUYER" ||
      userRoleCode == "SUPERADMIN"
        ? {
            name: "BankReportsUserRoleWise",
            title: "Buyer Statement",
            linkId: 104,
          }
        : "",
      userRoleCode == "BUYER" ||
      userRoleCode == "ASSOCIATEBUYER" ||
      userRoleCode == "POSTAUCTIONASSOCIATEBUYER" ||
      userRoleCode == "SUPERADMIN"
        ? {
            name: "BankReportsUserRoleWise",
            title: "Buyer Pay In MIS",
            linkId: 105,
          }
        : "",
      userRoleCode == "SELLER" || userRoleCode == "SUPERADMIN"
        ? {
            name: "BankReportsUserRoleWise",
            title: "Seller Detailed MIS",
            linkId: 106,
          }
        : "",
      userRoleCode == "SELLER" || userRoleCode == "SUPERADMIN"
        ? {
            name: "BankReportsUserRoleWise",
            title: "Seller Pay Out MIS",
            linkId: 107,
          }
        : "",
      userRoleCode == "TEABOARDUSER" || userRoleCode == "SUPERADMIN"
        ? {
            name: "BankReportsUserRoleWise",
            title: "Tea board Detailed MIS",
            linkId: 108,
          }
        : "",
      userRoleCode == "WAREHOUSE" || userRoleCode == "SUPERADMIN"
        ? {
            name: "BankReportsUserRoleWise",
            title: "Warehouse Bank MIS",
            linkId: 109,
          }
        : "",
      userRoleCode == "SELLER" || userRoleCode == "SUPERADMIN"
        ? {
            name: "BankReportsUserRoleWise",
            title: "Seller Statement",
            linkId: 110,
          }
        : "",
      userRoleCode == "SELLER" || userRoleCode == "SUPERADMIN"
        ? {
            name: "BankReportsUserRoleWise",
            title: "Seller SPTF MIS",
            linkId: 111,
          }
        : "",
      userRoleCode == "TEABOARDUSER" || userRoleCode == "SUPERADMIN"
        ? {
            name: "BankReportsUserRoleWise",
            title: "Tea Board Aging MIS",
            linkId: 112,
          }
        : "",
      userRoleCode == "TEABOARDUSER" || userRoleCode == "SUPERADMIN"
        ? {
            name: "BankReportsUserRoleWise",
            title: "Tea Board Payment Summary",
            linkId: 113,
          }
        : "",
      userRoleCode == "TEABOARDUSER" || userRoleCode == "SUPERADMIN"
        ? {
            name: "BankReportsUserRoleWise",
            title: "Tea Board Commission MIS",
            linkId: 114,
          }
        : "",
      userRoleCode == "TEABOARDUSER" || userRoleCode == "SUPERADMIN"
        ? {
            name: "BankReportsUserRoleWise",
            title: "Tea Board TCS MIS",
            linkId: 115,
          }
        : "",
      userRoleCode == "TEABOARDUSER" || userRoleCode == "SUPERADMIN"
        ? {
            name: "BankReportsUserRoleWise",
            title: "Payment Summary",
            linkId: 116,
          }
        : "",
      (userRoleCode == "BUYER" ||
        userRoleCode == "ASSOCIATEBUYER" ||
        userRoleCode == "POSTAUCTIONASSOCIATEBUYER" ||
        userRoleCode == "SUPERADMIN") &&
      url == "englishauction"
        ? {
            name: "test1",
            title: "Post Auction Catalog Report",
            linkId: 200,
          }
        : "",
      (userRoleCode == "AUCTIONEER" ||
        userRoleCode == "ASSOCIATEAUCTIONEER" ||
        userRoleCode == "POSTAUCTIONASSOCIATEAUCTIONEER" ||
        userRoleCode == "SUPERADMIN") &&
      url != "englishauction"
        ? { name: "test2", title: "Cash and Carry (CNC) Report", linkId: 201 }
        : (userRoleCode == "AUCTIONEER" ||
            userRoleCode == "ASSOCIATEAUCTIONEER" ||
            userRoleCode == "POSTAUCTIONASSOCIATEAUCTIONEER" ||
            userRoleCode == "SUPERADMIN") &&
          url == "englishauction"
        ? { name: "test117", title: "Cash and Carry (CNC) Report", linkId: 312 }
        : "",

      userRoleCode == "AUCTIONEER" ||
      userRoleCode == "ASSOCIATEAUCTIONEER" ||
      userRoleCode == "POSTAUCTIONASSOCIATEAUCTIONEER" ||
      userRoleCode == "SUPERADMIN"
        ? {
            name: "test3",
            title: "Auction Price List",
            linkId: 202,
          }
        : "",
      (userRoleCode == "AUCTIONEER" ||
        userRoleCode == "ASSOCIATEAUCTIONEER" ||
        userRoleCode == "POSTAUCTIONASSOCIATEAUCTIONEER" ||
        userRoleCode == "SUPERADMIN") &&
      url != "englishauction"
        ? { name: "test4", title: "Bill Contract Summary", linkId: 203 }
        : (userRoleCode == "AUCTIONEER" ||
            userRoleCode == "ASSOCIATEAUCTIONEER" ||
            userRoleCode == "POSTAUCTIONASSOCIATEAUCTIONEER" ||
            userRoleCode == "SUPERADMIN") &&
          url == "englishauction"
        ? { name: "test118", title: "Bill Contract Summary", linkId: 313 }
        : "",
      // (userRoleCode == "TAOUSER" || userRoleCode == "SUPERADMIN") ?
      //   { name: "test5", title: "Post Auction Catalog Report", linkId: 204 } : '',
      (userRoleCode == "AUCTIONEER" ||
        userRoleCode == "ASSOCIATEAUCTIONEER" ||
        userRoleCode == "POSTAUCTIONASSOCIATEAUCTIONEER" ||
        userRoleCode == "TEABOARDUSER" ||
        userRoleCode == "SUPERADMIN") &&
      url != "englishauction"
        ? { name: "test6", title: "Closing Price Trend Report", linkId: 205 }
        : "",
      userRoleCode == "AUCTIONEER" ||
      userRoleCode == "ASSOCIATEAUCTIONEER" ||
      userRoleCode == "POSTAUCTIONASSOCIATEAUCTIONEER" ||
      userRoleCode == "TEABOARDUSER" ||
      userRoleCode == "SUPERADMIN"
        ? {
            name: "test7",
            title:
              userRoleCode == "TEABOARDUSER"
                ? "Knock Down Report Auctioneer"
                : "Knock Down Report",
            linkId: 206,
          }
        : "",
      userRoleCode == "BUYER" ||
      userRoleCode == "ASSOCIATEBUYER" ||
      userRoleCode == "POSTAUCTIONASSOCIATEBUYER" ||
      userRoleCode == "TEABOARDUSER" ||
      userRoleCode == "SUPERADMIN"
        ? { name: "test8", title: "Knock Down Report", linkId: 207 }
        : "",
      (userRoleCode == "TAOUSER" ||
        userRoleCode == "TEABOARDUSER" ||
        userRoleCode == "SUPERADMIN") &&
      url != "englishauction"
        ? {
            name: "test9",
            title: "Knockdown Lots (Qty.) (TAO User)",
            linkId: 208,
          }
        : (userRoleCode == "TAOUSER" ||
            userRoleCode == "TEABOARDUSER" ||
            userRoleCode == "SUPERADMIN") &&
          url == "englishauction"
        ? {
            name: "test120",
            title: "Knockdown Lots (Qty.) (TAO User)",
            linkId: 315,
          }
        : "",
      // userRoleCode == "SUPERADMIN" && url != "englishauction"
      //   ? { name: "test10", title: "PayIn PayOut Report", linkId: 209 }
      //   : "",
      //Bharat
      (userRoleCode == "AUCTIONEER" ||
        userRoleCode == "ASSOCIATEAUCTIONEER" ||
        userRoleCode == "POSTAUCTIONASSOCIATEAUCTIONEER" ||
        userRoleCode == "SUPERADMIN") &&
      url != "englishauction"
        ? {
            name: "test11",
            title: "Unsold Lots Report",
            linkId: 210,
          }
        : "",
      //Bharat
      (userRoleCode == "TEABOARDUSER" ||
        userRoleCode == "BUYER" ||
        userRoleCode == "ASSOCIATEBUYER" ||
        userRoleCode == "POSTAUCTIONASSOCIATEBUYER" ||
        userRoleCode == "TAOUSER" ||
        userRoleCode == "SUPERADMIN") &&
      url != "englishauction"
        ? {
            name: "test12",
            title:
              userRoleCode == "TEABOARDUSER"
                ? "Unsold Lots Report Seller"
                : "Unsold Lots Report ",
            linkId: 211,
          }
        : "",
      //Bharat
      (userRoleCode == "SELLER" || userRoleCode == "SUPERADMIN") &&
      url != "englishauction"
        ? { name: "test13", title: "Unsold Lots Report", linkId: 212 }
        : "",
      userRoleCode == "AUCTIONEER" ||
      userRoleCode == "ASSOCIATEAUCTIONEER" ||
      userRoleCode == "POSTAUCTIONASSOCIATEAUCTIONEER" ||
      userRoleCode == "SUPERADMIN"
        ? { name: "test14", title: "View Buyer Details Report", linkId: 213 }
        : "",
      { name: "test15", title: "View Mark Details Report", linkId: 214 },
      userRoleCode == "AUCTIONEER" ||
      userRoleCode == "ASSOCIATEAUCTIONEER" ||
      userRoleCode == "POSTAUCTIONASSOCIATEAUCTIONEER" ||
      userRoleCode == "TEABOARDUSER" ||
      userRoleCode == "SUPERADMIN"
        ? { name: "test16", title: "View SPU Master Report", linkId: 215 }
        : "",
      userRoleCode == "WAREHOUSE" || userRoleCode == "SUPERADMIN"
        ? { name: "test17", title: "Warehouse Bill Summary", linkId: 216 }
        : "",
      userRoleCode == "TAOUSER" || userRoleCode == "SUPERADMIN"
        ? { name: "test18", title: "Manufacturer Sale Abstract", linkId: 216 }
        : "",
      userRoleCode == "TAOUSER" ||
      ((userRoleCode == "AUCTIONEER" ||
        userRoleCode == "ASSOCIATEAUCTIONEER" ||
        userRoleCode == "POSTAUCTIONASSOCIATEAUCTIONEER") &&
        url) ||
      (userRoleCode == "SUPERADMIN") == "englishauction"
        ? {
            name: "test19",
            title: "Month wise Arrivals of Fresh Teas Report",
            linkId: 217,
          }
        : "",
      // userRoleCode == "TAOUSER" || userRoleCode == "SUPERADMIN"
      //   ? { name: "test20", title: "Auction Catalog Summary", linkId: 218 }
      //   : "",
      userRoleCode == "TAOUSER" || userRoleCode == "SUPERADMIN"
        ? { name: "test20", title: "Auction Catalog Summary", linkId: 218 }
        : "",
      userRoleCode == "TAOUSER"
        ? {
            name: "test21",
            title: "Buyers Purchase Abstract",
            linkId: 219,
          }
        : "",
      userRoleCode == "TAOUSER" ||
      ((userRoleCode == "AUCTIONEER" ||
        userRoleCode == "ASSOCIATEAUCTIONEER" ||
        userRoleCode == "POSTAUCTIONASSOCIATEAUCTIONEER") &&
        url == "englishauction") ||
      userRoleCode == "SUPERADMIN"
        ? { name: "test22", title: "Tea Available", linkId: 220 }
        : "",
      // {
      //   name: "test23",
      //   title: "Knockdown Lots (Qty.) (TAO User) Report",
      //   linkId: 221,
      // },
      // { name: "test24", title: "Unsold Lots (TAO User) Report", linkId: 222 },
      // (userRoleCode == "AUCTIONEER" && url == "englishauction") ||
      // userRoleCode == "SUPERADMIN"
      //   ? {
      //       name: "test25",
      //       title: "Month wise / Category wise Sold Qty. (TTA Wise) Report",
      //       linkId: 223,
      //     }
      //   : "",
      userRoleCode == "TAOUSER" ||
      ((userRoleCode == "AUCTIONEER" ||
        userRoleCode == "ASSOCIATEAUCTIONEER" ||
        userRoleCode == "POSTAUCTIONASSOCIATEAUCTIONEER") &&
        url == "englishauction") ||
      userRoleCode == "SUPERADMIN"
        ? {
            name: "test26",
            title: "Historical Prices of Tea in Past Sale Programs",
            linkId: 224,
          }
        : "",
      ((userRoleCode == "AUCTIONEER" ||
        userRoleCode == "ASSOCIATEAUCTIONEER" ||
        userRoleCode == "POSTAUCTIONASSOCIATEAUCTIONEER") &&
        url == "englishauction") ||
      userRoleCode == "SUPERADMIN"
        ? { name: "test27", title: "Lots Pending Delivery", linkId: 225 }
        : "",
      userRoleCode == "TAOUSER" ||
      ((userRoleCode == "AUCTIONEER" ||
        userRoleCode == "ASSOCIATEAUCTIONEER" ||
        userRoleCode == "POSTAUCTIONASSOCIATEAUCTIONEER") &&
        url == "englishauction") ||
      userRoleCode == "SUPERADMIN"
        ? { name: "test28", title: "Lot Types", linkId: 226 }
        : "",
      userRoleCode == "TAOUSER" ||
      ((userRoleCode == "AUCTIONEER" ||
        userRoleCode == "ASSOCIATEAUCTIONEER" ||
        userRoleCode == "POSTAUCTIONASSOCIATEAUCTIONEER") &&
        url == "englishauction") ||
      userRoleCode == "SUPERADMIN"
        ? { name: "test29", title: "Sale Average Report", linkId: 227 }
        : "",
      userRoleCode == "TAOUSER"
        ? {
            name: "test30",
            title: "Buyer Outstanding Payment Details Report",
            linkId: 228,
          }
        : "",
      // { name: "test31", title: "Manufacturer Details Report", linkId: 229 },
      // { name: "test32", title: "Buyer Payment Status Report", linkId: 230 },
      userRoleCode == "TAOUSER" || userRoleCode == "SUPERADMIN"
        ? {
            name: "test33",
            title: "Publish and Edit Notification (By Admin) Report",
            linkId: 231,
          }
        : "",
      userRoleCode == "TEABOARDUSER" || userRoleCode == "SUPERADMIN"
        ? { name: "test34", title: "Registration Count", linkId: 232 }
        : "",
      userRoleCode == "TEABOARDUSER"
        ? { name: "test35", title: "Invoice Details", linkId: 233 }
        : "",
      userRoleCode == "TEABOARDUSER" || userRoleCode == "SUPERADMIN"
        ? { name: "test37", title: "Dashboard", linkId: 234 }
        : "",
      userRoleCode == "WAREHOUSE" || userRoleCode == "SUPERADMIN"
        ? { name: "test38", title: "Warehouse Bill", linkId: 235 }
        : "",

      userRoleCode == "WAREHOUSE" || userRoleCode == "SUPERADMIN"
        ? {
            name: "test39",
            title: "Knock Down Report",
            linkId: 236,
          }
        : "",
      userRoleCode == "WAREHOUSEUNIT" || userRoleCode == "SUPERADMIN"
        ? { name: "test40", title: "Delivery Order", linkId: 237 }
        : "",
      userRoleCode == "TEABOARDUSER" || userRoleCode == "SUPERADMIN"
        ? {
            name: "test41",
            title:
              "Tea Board Tax Invoices",
            linkId: 238,
          }
        : "",
      // userRoleCode == "TEABOARDUSER"
      //   ? {
      //     name: "test42",
      //     title: "Pending Tea Board Tax Invoices Summary Report",
      //     linkId: 239,
      //   }
      //   : "",
      // {
      //   name: "test43",
      //   title: "Pending Tea Board Tax Invoices Summary – Date wise Report",
      //   linkId: 240,
      // },
      userRoleCode == "TEABOARDUSER" || userRoleCode == "SUPERADMIN"
        ? { name: "test44", title: "SPTF Summary Report", linkId: 241 }
        : "",
      userRoleCode == "TEABOARDUSER" || userRoleCode == "SUPERADMIN"
        ? { name: "test45", title: "Tea Board SPTF MIS", linkId: 242 }
        : "",
      // userRoleCode == "SELLER" ? { name: "test46", title: "Published Catalog Report", linkId: 243 } : "",
      userRoleCode == "SELLER" || userRoleCode == "SUPERADMIN"
        ? {
            name: "test47",
            title: "Tea Value Invoice Details",
            linkId: 244,
          }
        : "",
      userRoleCode == "SELLER" || userRoleCode == "SUPERADMIN"
        ? {
            name: "test48",
            title: "Seller Tax Invoice Payable",
            linkId: 245,
          }
        : "",
      (userRoleCode == "SELLER" || userRoleCode == "SUPERADMIN") &&
      url != "englishauction"
        ? {
            name: "test49",
            title: "Pay In Pay Out",
            linkId: 246,
          }
        : "",
      (userRoleCode == "SELLER" || userRoleCode == "SUPERADMIN") &&
      url == "englishauction"
        ? {
            name: "test122",
            title: "Pay In Pay Out",
            linkId: 246,
          }
        : "",
      // { name: "test50", title: "Warehouse Summary", linkId: 247 },
      // { name: "test51", title: "TCS Invoices Report", linkId: 248 },
      userRoleCode == "WAREHOUSE" || userRoleCode == "SUPERADMIN"
        ? { name: "test52", title: "Payment Status Report", linkId: 249 }
        : "",
      // { name: "test53", title: "TDS Invoices Report", linkId: 250 },
      userRoleCode == "BUYER" ||
      userRoleCode == "ASSOCIATEBUYER" ||
      userRoleCode == "POSTAUCTIONASSOCIATEBUYER" ||
      userRoleCode == "TEABOARDUSER" ||
      userRoleCode == "SUPERADMIN"
        ? {
            name: "test54",
            title:
              userRoleCode == "TEABOARDUSER"
                ? "Payment Status Report Buyer"
                : "Payment Status Report",
            linkId: 251,
          }
        : "",
      userRoleCode == "BUYER" ||
      userRoleCode == "ASSOCIATEBUYER" ||
      userRoleCode == "POSTAUCTIONASSOCIATEBUYER" ||
      userRoleCode == "SUPERADMIN"
        ? {
            name: "test55",
            title: "Tax Invoice Details Report",
            linkId: 252,
          }
        : "",
      userRoleCode == "BUYER" ||
      userRoleCode == "ASSOCIATEBUYER" ||
      userRoleCode == "POSTAUCTIONASSOCIATEBUYER" ||
      userRoleCode == "SUPERADMIN"
        ? {
            name: "test56",
            title: "Max Bid History Report",
            linkId: 253,
          }
        : "",
      userRoleCode == "BUYER" ||
      userRoleCode == "ASSOCIATEBUYER" ||
      userRoleCode == "POSTAUCTIONASSOCIATEBUYER" ||
      userRoleCode == "TEABOARDUSER" ||
      userRoleCode == "SUPERADMIN"
        ? {
            name: "test57",
            title:
              userRoleCode == "TEABOARDUSER"
                ? "Entry / Exit Prices Report (Buyer)"
                : "Entry / Exit Prices Report",
            linkId: 254,
          }
        : "",
      userRoleCode == "BUYER" ||
      userRoleCode == "ASSOCIATEBUYER" ||
      userRoleCode == "POSTAUCTIONASSOCIATEBUYER" ||
      userRoleCode == "SUPERADMIN"
        ? {
            name: "test58",
            title: "TCS Collected by Seller Report",
            linkId: 255,
          }
        : "",
      userRoleCode == "BUYER" ||
      userRoleCode == "ASSOCIATEBUYER" ||
      userRoleCode == "POSTAUCTIONASSOCIATEBUYER" ||
      userRoleCode == "SUPERADMIN"
        ? {
            name: "test59",
            title: "Auction Price List",
            linkId: 256,
          }
        : "",
      userRoleCode == "BUYER" ||
      userRoleCode == "ASSOCIATEBUYER" ||
      userRoleCode == "POSTAUCTIONASSOCIATEBUYER" ||
      userRoleCode == "SUPERADMIN"
        ? {
            name: "test60",
            title: "View PAN India Buyers",
            linkId: 257,
          }
        : "",

      userRoleCode == "BUYER" ||
      userRoleCode == "ASSOCIATEBUYER" ||
      userRoleCode == "POSTAUCTIONASSOCIATEBUYER" ||
      userRoleCode == "SUPERADMIN"
        ? {
            name: "test61",
            title: "Charges Master",
            linkId: 258,
          }
        : "",
      userRoleCode == "BUYER" ||
      userRoleCode == "ASSOCIATEBUYER" ||
      userRoleCode == "POSTAUCTIONASSOCIATEBUYER" ||
      userRoleCode == "SUPERADMIN"
        ? {
            name: "test62",
            title: "View Tax Details",
            linkId: 259,
          }
        : "",
      // {
      //   name: "test63",
      //   title: "Buyer Detailed MIS Report",
      //   linkId: 260,
      // },
      userRoleCode == "SELLER" || userRoleCode == "SUPERADMIN"
        ? {
            name: "test64",
            title: "Knock Down Report",
            linkId: 261,
          }
        : "",
      // {
      //   name: "test65",
      //   title: "Unsold (Unused) lots report (Seller)",
      //   linkId: 262,
      // },
      userRoleCode == "TAOUSER" ||
      ((userRoleCode == "AUCTIONEER" ||
        userRoleCode == "ASSOCIATEAUCTIONEER" ||
        userRoleCode == "POSTAUCTIONASSOCIATEAUCTIONEER") &&
        url == "englishauction") ||
      userRoleCode == "SUPERADMIN"
        ? {
            name: "test66",
            title: "Auctioneer’s Tasting and Valuation Report",
            linkId: 263,
          }
        : "",
      userRoleCode == "WAREHOUSE" || userRoleCode == "SUPERADMIN"
        ? {
            name: "test67",
            title: "Warehouse Pay In Pay Out and Details",
            linkId: 264,
          }
        : "",
      // { name: "test68", title: "Delivery Order Warehouse Unit", linkId: 265 },
      // userRoleCode == "TEABOARDUSER" || userRoleCode == "SUPERADMIN"
      //   ? {
      //       name: "test69",
      //       title: "Tea Board Tax Invoices",
      //       linkId: 266,
      //     }
      //   : "",
      userRoleCode == "TEABOARDUSER" || userRoleCode == "SUPERADMIN"
        ? {
            name: "test71",
            title: "Tea Board Tax Invoices Summary – Date wise",
            linkId: 268,
          }
        : "",
      userRoleCode == "TEABOARDUSER" || userRoleCode == "SUPERADMIN"
        ? {
            name: "test70",
            title: "Tea Board Tax Invoices Summary",
            linkId: 267,
          }
        : "",
      // userRoleCode == "TEABOARDUSER"
      //   ? {
      //       name: "test71",
      //       title: "Pending Tea Board Tax Invoices Summary – Date wise",
      //       linkId: 268,
      //     }
      //   : "",
      // userRoleCode == "TEABOARDUSER"
      //   ? { name: "test72", title: "SPTF Summary", linkId: 269 }
      //   : "",
      userRoleCode == "SELLER" || userRoleCode == "SUPERADMIN"
        ? {
            name: "test73",
            title: "Published Catalog",
            linkId: 270,
          }
        : "",
      // userRoleCode == "SELLER" || userRoleCode == "SUPERADMIN"
      //   ? {
      //       name: "test73",
      //       title: "Published Catalog",
      //       linkId: 270,
      //     }
      //   : "",
      userRoleCode == "SELLER" || userRoleCode == "SUPERADMIN"
        ? {
            name: "test74",
            title: "Cash and Carry",
            linkId: 271,
          }
        : "",
      // userRoleCode == "SELLER" || userRoleCode == "SUPERADMIN"
      //   ? {
      //       name: "test75",
      //       title: "Seller Tax Invoice Payable-Factory Owner Report",
      //       linkId: 272,
      //     }
      //   : "",
      userRoleCode == "SELLER" || userRoleCode == "SUPERADMIN"
        ? {
            name: "test76",
            title: "WareHouse Summary",
            linkId: 273,
          }
        : "",
      (userRoleCode == "SELLER" && url !== "englishauction") ||
      userRoleCode == "SUPERADMIN"
        ? {
            name: "test77",
            title: "TCS Invoices Report",
            linkId: 274,
          }
        : "",
      userRoleCode == "SELLER" || userRoleCode == "SUPERADMIN"
        ? {
            name: "test78",
            title: "Payment Status Report",
            linkId: 275,
          }
        : "",
      userRoleCode == "SELLER" || userRoleCode == "SUPERADMIN"
        ? {
            name: "test79",
            title: "TDS Invoices Report",
            linkId: 276,
          }
        : "",
      userRoleCode == "SELLER" || userRoleCode == "SUPERADMIN"
        ? {
            name: "test80",
            title: "TCS Report Summary",
            linkId: 277,
          }
        : "",
      userRoleCode == "SELLER" || userRoleCode == "SUPERADMIN"
        ? {
            name: "test81",
            title: "TCS Report Collected by Seller",
            linkId: 278,
          }
        : "",
      userRoleCode == "SELLER" ||
      userRoleCode == "TEABOARDUSER" ||
      userRoleCode == "SUPERADMIN"
        ? {
            name: "test82",
            title: "SPTF Recovery",
            linkId: 279,
          }
        : "",
      userRoleCode == "TEABOARDUSER" || userRoleCode == "SUPERADMIN"
        ? { name: "test83", title: "Audit Trail Report link", linkId: 280 }
        : "",
      userRoleCode == "TEABOARDUSER" || userRoleCode == "SUPERADMIN"
        ? { name: "test84", title: "Login Report link", linkId: 281 }
        : "",
      userRoleCode == "TEABOARDUSER" ||
      userRoleCode == "TAOUSER" ||
      userRoleCode == "SUPERADMIN"
        ? { name: "test85", title: "User Management History link", linkId: 282 }
        : "",
      userRoleCode == "TEABOARDUSER" ||
      userRoleCode == "TAOUSER" ||
      userRoleCode == "SUPERADMIN"
        ? { name: "test86", title: "Mail acknowledgement report", linkId: 283 }
        : "",
      userRoleCode == "TEABOARDUSER" ||
      userRoleCode == "TAOUSER" ||
      userRoleCode == "SUPERADMIN"
        ? {
            name: "test87",
            title: "Auction Management Report",
            linkId: 284,
          }
        : "",
      userRoleCode == "BUYER" ||
      userRoleCode == "SELLER" ||
      userRoleCode == "AUCTIONEER" ||
      userRoleCode == "ASSOCIATEAUCTIONEER" ||
      userRoleCode == "POSTAUCTIONASSOCIATEAUCTIONEER" ||
      userRoleCode == "ASSOCIATEBUYER" ||
      userRoleCode == "POSTAUCTIONASSOCIATEBUYER" ||
      userRoleCode == "SUPERADMIN"
        ? { name: "test88", title: "Notification", linkId: 285 }
        : "",
      // { name: "test89", title: "Bid History MISC Report", linkId: 286 },
      (userRoleCode == "BUYER" ||
        userRoleCode == "ASSOCIATEBUYER" ||
        userRoleCode == "POSTAUCTIONASSOCIATEBUYER" ||
        userRoleCode == "TEABOARDUSER" ||
        userRoleCode == "SUPERADMIN") &&
      url != "englishauction"
        ? {
            name: "test90",
            title:
              userRoleCode == "TEABOARDUSER"
                ? "Post Auction Catalog Report Buyer"
                : "Post Auction Catalog Report",
            linkId: 287,
          }
        : "",
      // { name: "test91", title: "Post Auction Auctioneer Report", linkId: 288 },
      userRoleCode == "AUCTIONEER" ||
      userRoleCode == "ASSOCIATEAUCTIONEER" ||
      userRoleCode == "POSTAUCTIONASSOCIATEAUCTIONEER" ||
      userRoleCode == "TEABOARDUSER" ||
      userRoleCode == "SUPERADMIN"
        ? {
            name: "test92",
            title: "Payment Status Auctioneer Report",
            linkId: 289,
          }
        : "",
      userRoleCode == "AUCTIONEER" ||
      userRoleCode == "ASSOCIATEAUCTIONEER" ||
      userRoleCode == "POSTAUCTIONASSOCIATEAUCTIONEER" ||
      userRoleCode == "TEABOARDUSER" ||
      userRoleCode == "SUPERADMIN"
        ? {
            name: "test93",
            title: "View Warehouse Details Report",
            linkId: 290,
          }
        : "",
      userRoleCode == "AUCTIONEER" ||
      userRoleCode == "ASSOCIATEAUCTIONEER" ||
      userRoleCode == "POSTAUCTIONASSOCIATEAUCTIONEER" ||
      userRoleCode == "TEABOARDUSER" ||
      userRoleCode == "SUPERADMIN"
        ? {
            name: "test94",
            title:
              userRoleCode == "TEABOARDUSER"
                ? "View Tax Details Report Auctioneer"
                : "View Tax Details Report",
            linkId: 291,
          }
        : "",
      (userRoleCode == "AUCTIONEER" ||
        userRoleCode == "ASSOCIATEAUCTIONEER" ||
        userRoleCode == "POSTAUCTIONASSOCIATEAUCTIONEER" ||
        userRoleCode == "TEABOARDUSER" ||
        userRoleCode == "SUPERADMIN") &&
      url == "auctionPage"
        ? {
            name: "test95",
            title:
              userRoleCode == "TEABOARDUSER"
                ? "Post Auction Catalog Report Auctioneer"
                : "Post Auction Catalog Report",
            linkId: 292,
          }
        : "",
      // userRoleCode == "BUYER" ||
      // userRoleCode == "ASSOCIATEBUYER" ||
      // userRoleCode == "POSTAUCTIONASSOCIATEBUYER" ||
      // userRoleCode == "SUPERADMIN"
      //   ? {
      //       name: "test96",
      //       title: "View Mark Details Buyer Report",
      //       linkId: 293,
      //     }
      //   : "",
      (userRoleCode == "TAOUSER" && url == "auctionPage") ||
      userRoleCode == "SUPERADMIN"
        ? {
            name: "test97",
            title: "Post Auction Catalog Report",
            linkId: 294,
          }
        : "",
      ((userRoleCode == "AUCTIONEER" ||
        userRoleCode == "ASSOCIATEAUCTIONEER" ||
        userRoleCode == "POSTAUCTIONASSOCIATEAUCTIONEER") &&
        url == "englishauction") ||
      userRoleCode == "SUPERADMIN"
        ? {
            name: "test98",
            title: "Auction Catalog Summary",
            linkId: 295,
          }
        : "",
      userRoleCode == "AUCTIONEER" ||
      userRoleCode == "ASSOCIATEAUCTIONEER" ||
      userRoleCode == "POSTAUCTIONASSOCIATEAUCTIONEER" ||
      userRoleCode == "TEABOARDUSER" ||
      userRoleCode == "SUPERADMIN"
        ? {
            name: "test99",
            title: "Warehouse Bill Summary",
            linkId: 296,
          }
        : "",
      (userRoleCode == "AUCTIONEER" ||
        userRoleCode == "ASSOCIATEAUCTIONEER" ||
        userRoleCode == "POSTAUCTIONASSOCIATEAUCTIONEER" ||
        userRoleCode == "SUPERADMIN") &&
      url != "englishauction"
        ? {
            name: "test100",
            title: "Seller Tax Invoice Summary",
            linkId: 297,
          }
        : (userRoleCode == "AUCTIONEER" ||
            userRoleCode == "ASSOCIATEAUCTIONEER" ||
            userRoleCode == "POSTAUCTIONASSOCIATEAUCTIONEER" ||
            userRoleCode == "SUPERADMIN") &&
          url == "englishauction"
        ? {
            name: "test119",
            title: "Seller Tax Invoice Summary",
            linkId: 314,
          }
        : "",
      userRoleCode == "AUCTIONEER" ||
      userRoleCode == "ASSOCIATEAUCTIONEER" ||
      userRoleCode == "POSTAUCTIONASSOCIATEAUCTIONEER" ||
      userRoleCode == "SUPERADMIN"
        ? {
            name: "test101",
            title: "Delivery Instruction/Advice (DI) Register",
            linkId: 298,
          }
        : "",
      userRoleCode == "AUCTIONEER" ||
      userRoleCode == "ASSOCIATEAUCTIONEER" ||
      userRoleCode == "POSTAUCTIONASSOCIATEAUCTIONEER" ||
      userRoleCode == "SUPERADMIN"
        ? {
            name: "test102",
            title: "Issuer Invoice Details",
            linkId: 299,
          }
        : "",
      userRoleCode == "AUCTIONEER" ||
      userRoleCode == "ASSOCIATEAUCTIONEER" ||
      // userRoleCode == "POSTAUCTIONASSOCIATEAUCTIONEER"
      //   ? {
      //       name: "test103",
      //       title: "TCS Details",
      //       linkId: 300,
      //     }
      //   : "",
      // +(
      // { name: "test104", title: "TDS Invoice Auctioneer Report", linkId: 301 },
      userRoleCode == "TAOUSER" ||
      userRoleCode == "AUCTIONEER" ||
      userRoleCode == "ASSOCIATEAUCTIONEER" ||
      userRoleCode == "POSTAUCTIONASSOCIATEAUCTIONEER" ||
      userRoleCode == "SUPERADMIN"
        ? {
            name: "test105",
            title: "Lots Removed From Kutcha (Draft) Catalog",
            linkId: 302,
          }
        : "",

      // { name: "test104", title: "TDS Invoice Auctioneer Report", linkId: 301 },
      // userRoleCode == "TAOUSER" ||
      // ((userRoleCode == "AUCTIONEER" ||
      //   userRoleCode == "ASSOCIATEAUCTIONEER" ||
      //   userRoleCode == "POSTAUCTIONASSOCIATEAUCTIONEER") &&
      //   url == "englishauction") ||
      // userRoleCode == "SUPERADMIN"
      //   ? {
      //       name: "test105",
      //       title: "Lots Removed From Kutcha (Draft) Catalog",
      //       linkId: 302,
      //     }
      //   : "",
      //english
      (userRoleCode == "TEABOARDUSER" ||
        userRoleCode == "BUYER" ||
        userRoleCode == "ASSOCIATEBUYER" ||
        userRoleCode == "POSTAUCTIONASSOCIATEBUYER" ||
        userRoleCode == "TAOUSER" ||
        userRoleCode == "SUPERADMIN") &&
      url == "englishauction"
        ? {
            name: "test106",
            title: "Unsold Lots Report",
            linkId: 303,
          }
        : "",
      (userRoleCode == "AUCTIONEER" ||
        userRoleCode == "ASSOCIATEAUCTIONEER" ||
        userRoleCode == "POSTAUCTIONASSOCIATEAUCTIONEER" ||
        userRoleCode == "TEABOARDUSER" ||
        userRoleCode == "SUPERADMIN") &&
      url == "englishauction"
        ? {
            name: "test107",
            title:
              userRoleCode == "TEABOARDUSER"
                ? "Post Auction Catalog Report Auctioneer"
                : "Post Auction Catalog Report ",
            linkId: 304,
          }
        : "",
      (url == "englishauction" &&
        (userRoleCode == "TAOUSER" ||
          userRoleCode == "AUCTIONEER" ||
          userRoleCode == "BUYER" ||
          userRoleCode == "SELLER" ||
          userRoleCode == "ASSOCIATEAUCTIONEER" ||
          userRoleCode == "POSTAUCTIONASSOCIATEAUCTIONEER")) ||
      userRoleCode == "SUPERADMIN"
        ? {
            name: "bidhistoryReportEnglish",
            title: "View bid",
            linkId: 302,
          }
        : "",
      (userRoleCode == "TAOUSER" && url == "englishauction") ||
      userRoleCode == "SUPERADMIN"
        ? {
            name: "test108",
            title: "Post Auction Catalog Report",
            linkId: 305,
          }
        : "",
      //english
      ((userRoleCode == "AUCTIONEER" ||
        userRoleCode == "ASSOCIATEAUCTIONEER" ||
        userRoleCode == "POSTAUCTIONASSOCIATEAUCTIONEER") &&
        url == "englishauction") ||
      userRoleCode == "SUPERADMIN"
        ? {
            name: "test109",
            title: "Unsold Lots Report",
            linkId: 306,
          }
        : "",
      //english
      (userRoleCode == "SELLER" && url == "englishauction") ||
      userRoleCode == "SUPERADMIN"
        ? {
            name: "test110",
            title: "Unsold Lots Report",
            linkId: 307,
          }
        : "",

      url != "englishauction"
        ? {
            name: "auctionBidHistoryReport",
            title: "Bid History Report",
            linkId: 308,
          }
        : "",
      userRoleCode == "TAOUSER" || userRoleCode == "SUPERADMIN"
        ? {
            name: "test111",
            title: "Lots Pending Delivery",
            linkId: 309,
          }
        : "",
      userRoleCode == "TAOUSER" || userRoleCode == "SUPERADMIN"
        ? { name: "test112", title: "View Buyers Details", linkId: 310 }
        : "",
      userRoleCode == "TAOUSER" || userRoleCode == "SUPERADMIN"
        ? {
            name: "test115",
            title: "Auction Price List",
            linkId: 311,
          }
        : "",

      // -----------------------------------------------------------------------------

      userRoleCode == "AUCTIONEER" ||
      userRoleCode == "ASSOCIATEAUCTIONEER" ||
      userRoleCode == "POSTAUCTIONASSOCIATEAUCTIONEER" ||
      userRoleCode == "SUPERADMIN"
        ? {
            name: "1",
            title: "TCS Details",
            linkId: 500,
          }
        : "",

      userRoleCode == "SELLER" || userRoleCode == "SUPERADMIN"
        ? {
            name: "2",
            title: "TCS Invoices Report",
            linkId: 501,
          }
        : "",

      userRoleCode == "AUCTIONEER" ||
      userRoleCode == "ASSOCIATEAUCTIONEER" ||
      userRoleCode == "POSTAUCTIONASSOCIATEAUCTIONEER" ||
      userRoleCode == "SUPERADMIN"
        ? {
            name: "3",
            title: "TDS Invoice Report",
            linkId: 502,
          }
        : "",

      userRoleCode == "SELLER" || userRoleCode == "SUPERADMIN"
        ? {
            name: "4",
            title: "TDS Invoice Report",
            linkId: 503,
          }
        : "",

      userRoleCode == "WAREHOUSE" || userRoleCode == "SUPERADMIN"
        ? {
            name: "5",
            title: "Download Tax Invoice Document",
            linkId: 504,
          }
        : "",

      ((userRoleCode == "AUCTIONEER" ||
        userRoleCode == "ASSOCIATEAUCTIONEER" ||
        userRoleCode == "POSTAUCTIONASSOCIATEAUCTIONEER") &&
        url == "englishauction") ||
      userRoleCode == "TAOUSER" ||
      userRoleCode == "SUPERADMIN"
        ? {
            name: "6",
            title: "Month wise / Category wise Sold Qty. (TTA Wise)",
            linkId: 505,
          }
        : "",

      userRoleCode == "TAOUSER" || userRoleCode == "SUPERADMIN"
        ? {
            name: "7",
            title: "Buyer Payment Status Report",
            linkId: 506,
          }
        : "",
    ],

    show: true,
    modalName: "Report",
  },
  {
    show: true,
    modalName: "LSP",
    title: "LSP calculation",
    moduleId: 6,
    content: [
      // { name: "categoryMaster", title: "Category master" },
      // { name: "manufactureMapping", title: "Manufacture Mapping" },
      // { name: "gradeMaster", title: "Grade Master" },
      // { name: "markMaster", title: "Mark Master" },
      { linkId: 1, name: "lspCalculation", title: "LSP calculation" },
    ],
  },

  {
    title: "Miscellaneous",
    content: "XXX XXX XXX",
    show: true,
    modalName: "Miscellaneous",
  },
  {
    title: "Profile",
    moduleId: 99,
    content: [
      { linkId: 299, name: "profileupdatelink", title: "Profile Update Link" },
    ],
    show: true,
    modalName: "profileupdatelink",
  },
  {
    title: "Bank Detail Update",
    moduleId: 100,
    content: [
      { linkId: 300, name: "bankdetailupdate", title: "Bank Detail Update" },
    ],
    show: true,
    modalName: "bankdetailupdate",
  },
  {
    title: "ContactUs",
    moduleId: 101,
    content: [{ linkId: 301, name: "contactUs", title: "Contact Us" }],
    show: true,
    modalName: "contactUs",
  },
  {
    title: "Support",
    moduleId: 102,
    content: [
      { linkId: 302, name: "support", title: "Support" },
      // { linkId: 302, name: "test", title: "Test" },
    ],
    show: true,
    modalName: "support",
  },
];
export default SidebarContant;
